import {MDCRipple} from '@material/ripple';
import { useCallback, useRef } from 'preact/hooks';
import clsx from 'clsx';
import type { VNode, JSX } from 'preact';


export type IconFlowIconButtonProps = {
  text?: string
  icon?: VNode
  onClick?: JSX.MouseEventHandler<HTMLButtonElement>
  isSelected: boolean
}

export default function IconFlowIconButton({ text, icon, onClick, isSelected }: IconFlowIconButtonProps) {
  const ref = useRef<MDCRipple | null>(null)

  const setRef = useCallback((button: HTMLButtonElement) => {
    if(ref.current) {
      ref.current.destroy()
    }
    if(button) {
      ref.current = new MDCRipple(button)
    } else {
      ref.current = null
    }
  }, [])

  return (
    <button className={clsx('icon-flow-icon-button', "mdc-button mdc-button--raised", isSelected && 'selected', !icon && "no-icon")} onClick={onClick} ref={setRef}>
      {icon}
      <div className='button-text'>
        {text}
      </div>
    </button>
  )
}
